export default __webpack_public_path__ + "static/ancienne-lorette-1bb5001e9004f95770d19106ed96dbd4.png";